/**
 * A rate matrix that holds cells must mark one of them as the active variant, because the active
 * variant is the offer the vehicle advertises. An empty matrix has nothing to mark, so it is valid.
 */
export function hasValidActiveRateMatrixCell<TCell>(
  cells: TCell[],
  isActiveCell: (cell: TCell) => boolean
) {
  return cells.length === 0 || cells.some(isActiveCell);
}
